<template>
	<div class="flex w-full justify-center">
		<div class="pb-20 lg:pt-10 w-full max-w-5xl lg:max-w-6xl xl:max-w-7xl">
			<CartItems ref="cartComponent" v-slot="{ emptyBag, reduceItemQty, increaseItemQty, removeItem, reduceCertQty, increaseCertQty, removeCert }">
				<div class="flex justify-center md:pb-6 md:pt-0 fixed md:static top-20 md:top-0 z-20 bg-white w-full">
					<div class="flex w-full m-auto justify-between items-center border-t md:border-none shadow md:shadow-none py-6 px-4 md:px-8">
						<div class="flex w-full m-auto gap-x-2" :class="!store.cartTotalItems ? 'justify-center items-center' : 'text-2xl'">
							<div class="rounded-full" v-if="store.cartTotalItems">
								<FooterLogo width="65px" />
							</div>
							<div class="flex flex-col">
								<div class="text-ihh-midnight-gray font-semibold flex mr-2" :class="!store.cartTotalItems ? 'text-4xl' : 'text-2xl'">
									<span class="mr-1.5">Your Cart</span>
									<span v-if="!store.cartTotalItems">is Empty</span>
								</div>
								<div v-if="store.cartTotalItems" class="text-sm text-ihh-gray-500 font-normal">
									<span class="pl-1">{{ (store?.cart?.cartItems?.length || 0) + (store?.cart?.certificates?.length || 0) }}</span>
									<span>{{ store.cartTotalItems === 1 ? ' Item' : ' Items' }}</span>
								</div>
							</div>
						</div>
						<div v-if="store.cartTotalItems" class="">
							<div class="flex flex-col">
								<span class="font-semibold text-xl text-ihh-midnight-gray">{{
									(store.cart.subTotal || store.cartSubtotal).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
								}}</span>
								<span class="text-sm text-ihh-gray-500">Subtotal</span>
							</div>
						</div>
					</div>
				</div>

				<div class="px-4 md:px-0 pt-16 md:pt-0">
					<div :class="store.cartTotalItems === 0 ? 'flex w-full justify-center cursor-pointer group pt-32 md:pt-8' : 'hidden'">
						<router-link class="hover:bg-ihh-salmon bg-ihh-dark-salmon px-4 py-2 rounded text-white text-base" :to="`/`"> Continue Shopping </router-link>
					</div>

					<div :class="store.cart.tax === null ? 'flex w-full justify-center items-center' : 'hidden'">
						<div :class="store.cartTotalItems >= 1 ? 'flex w-full justify-center items-center inset-0 fixed bg-ihh-white/75 z-50' : 'hidden'">
							<Spinner :small="true" color="border-t-ihh-salmon" class="delay-500 w-28 h-28" />
						</div>
					</div>

					<!-- Cart Items Table -->
					<div class="hidden md:flex px-8">
						<table :class="!store.cartTotalItems ? 'hidden' : 'table-auto w-full justify-between'">
							<thead class="">
								<tr class="border-b text-ihh-slate-gray">
									<th class="p-4 text-start">Item</th>
									<th class="p-4 text-center">Price</th>
									<th class="p-4 text-center">Quantity</th>
									<th class="p-4 text-center">Total</th>
								</tr>
							</thead>
							<!-- <tbody class="table-auto w-full justify-between" v-for="{ item, quantity, variant, group, optional } in store.cart.cartItems" :key="item.id">
								<tr class="border-b">
									<td class="flex items-center py-6 px-4">
										<div class="flex flex-col justify-center w-[80px] h-[80px] shrink-0 mr-6">
											<img
												:src="variant?.imageUrl || item.images?.find((image) => image.isThumbnail)?.url"
												class="w-full max-w-[80px] max-h-[80px] object-contain"
											/>
										</div>
										<div class="flex flex-col text-start px-4">
											<router-link
												:to="`/products/${item.id}`"
												class="items-center cursor-pointer text-ihh-dark-salmon hover:text-ihh-salmon underline underline-offset-2 font-semibold"
											>
												{{ item.name }}
											</router-link>
											<div v-if="item.brand?.name" class="text-ihh-slate-gray mt-0 pt-0 mb-2 items-top text-xs">
												{{ item.brand?.name }}
											</div>
											<div v-if="variant" class="text-ihh-midnight-gray font-medium mt-2 text-xs">
												<div v-for="option in variant.optionValues">
													<span class="text-ihh-midnight-gray font-semibold">{{ `${option.optionDisplayName}: ` }}</span>
													<span class="text-ihh-gray-700 font-normal">{{ option.label }}</span>
												</div>
											</div>
											<div v-if="XCoverProducts.includes(item?.bcId)" class="text-ihh-midnight-gray font-medium mt-2">
												<div class="text-xs">
													<span>{{ `Covered Product Code: ` }}</span>
													<span class="text-ihh-gray font-normal">{{ optional?.coveredProductCode }}</span>
												</div>
												<div class="text-xs">
													<span>{{ `Covered Product: ` }}</span>
													<span class="text-ihh-gray font-normal">{{ optional.productName }}</span>
												</div>
											</div>
										</div>
									</td>
									<td class="py-6 px-4 text-center text-ihh-slate-gray">${{ variant?.calculatedPrice?.toFixed(2) || item?.calculatedPrice?.toFixed(2) }}</td>
									<td class="py-6 px-4 text-center text-ihh-slate-gray font-semibold">
										<div class="flex w-full justify-center">
											<div class="flex w-28 justify-around max-w-[100px]">
												<button
													@click="reduceItemQty(item.id)"
													class="shadow shadow-ihh-midnight-gray/20 m-auto flex w-5 h-5 rounded-full drop-shadow-2xl shadow-black bg-white items-center justify-center"
												>
													-
												</button>
												<div class="m-auto text-sm">{{ quantity }}</div>
												<button
													@click="increaseItemQty(item.id)"
													class="shadow shadow-ihh-midnight-gray/20 m-auto flex w-5 h-5 rounded-full drop-shadow-2xl shadow-black bg-white items-center justify-center"
												>
													+
												</button>
											</div>
										</div>
									</td>
									<td class="py-6 px-4 ml-4 text-center text-ihh-slate-gray">
										<div class="flex w-full justify-center">
											<div class="flex m-auto items-center space-x-4">
												<span>${{ ((variant?.calculatedPrice?.toFixed(2) || item?.calculatedPrice?.toFixed(2)) * quantity).toFixed?.(2) }}</span>
											</div>
										</div>
									</td>
									<td class="py-6 px-4 ml-4 text-center text-ihh-slate-gray">
										<div class="flex w-full justify-center m-auto gap-x-2 sm:gap-x-6">
											<div class="">
												<button
													@click="removeItem(item.id)"
													class="flex group w-7 h-7 p-2 justify-around z-10 hover:bg-ihh-slate-gray bg-ihh-gray/20 rounded-full font-bold text-xl text-ihh-midnight-gray"
												>
													<div class="m-auto items-center flex w-full justify-center">
														<div class="rotate-45 absolute bg-ihh-midnight-gray group-hover:bg-ihh-white py-[0.5px] rounded px-1"></div>
														<div class="-rotate-45 bg-ihh-midnight-gray group-hover:bg-ihh-white py-[0.5px] rounded px-1"></div>
													</div>
												</button>
											</div>
										</div>
									</td>
								</tr>
							</tbody> -->

							<tbody class="table-auto w-full justify-between">
								<CartItemDesktop
									v-for="{ item, quantity, variant, group, optional } in store.cart.cartItems"
									:key="item.id"
									:item="{ item, quantity, variant, group, optional }"
									:XCoverProducts="XCoverProducts"
									@reduce-qty="reduceItemQty"
									@increase-qty="increaseItemQty"
									@remove-item="removeItem"
								/>
							</tbody>
						</table>
					</div>

					<!-- Show this if screen is under md: size -->
					<div class="md:hidden mt-12">
						<!-- <div
							id="mobile-cart-items"
							v-for="{ item, quantity, variant, group, optional } in store.cart.cartItems"
							:key="item.id"
							class="py-6 border-b last:border-b-0 last:pb-0"
						>
							<div class="flex w-full justify-center my-6 space-x-2">
								<div class="flex flex-col justify-center w-[80px] h-[80px] shrink-0">
									<img
										:src="variant?.imageUrl || item.images?.find((image) => image.isThumbnail)?.url"
										class="max-w-[80px] max-h-[80px] object-contain rounded"
									/>
								</div>
								<div class="w-full">
									<div class="flex w-full">
										<div class="text-ihh-midnight-gray w-full max-w-52 mr-4">
											<div class="font-semibold text-base text-ihh-dark-salmon">{{ item.name }}</div>
											<div class="text-xs">{{ item.brand?.name }}</div>
										</div>
										<div class="text-ihh-midnight-gray text-lg">${{ variant?.calculatedPrice?.toFixed?.(2) || item?.calculatedPrice?.toFixed(2) }}</div>
									</div>
									<div v-if="variant" class="text-ihh-midnight-gray font-semibold pt-2 px-2 text-xs">
										<div v-for="option in variant.optionValues">
											<span>{{ `${option.optionDisplayName}: ` }}</span>
											<span class="text-ihh-gray font-normal">{{ option.label }}</span>
										</div>
										<div v-if="XCoverProducts.includes(item?.bcId)">
											<span>{{ `Covered Product Code: ` }}</span>
											<span class="text-ihh-gray font-normal">{{ optional?.coveredProductCode }}</span>
										</div>
										<div v-if="XCoverProducts.includes(item?.bcId)">
											<span>{{ `Covered Product: ` }}</span>
											<span class="text-ihh-gray font-normal">{{ optional.productName }}</span>
										</div>
									</div>
								</div>
							</div>

							<div class="flex w-full justify-between text-sm text-ihh-midnight-gray">
								<div class="flex w-32 justify-around max-w-[120px]">
									<button
										@click="reduceItemQty(variant?.id || item.id)"
										class="shadow shadow-ihh-midnight-gray/20 m-auto flex w-7 h-7 rounded-full drop-shadow-2xl shadow-black bg-white items-center justify-center text-lg font-medium"
									>
										-
									</button>
									<div class="m-auto text-base font-medium">{{ quantity }}</div>
									<button
										@click="increaseItemQty(variant?.id || item.id)"
										class="shadow shadow-ihh-midnight-gray/20 m-auto flex w-7 h-7 rounded-full drop-shadow-2xl shadow-black bg-white items-center justify-center text-lg font-medium"
									>
										+
									</button>
								</div>
								<div class="">
									<button
										@click="removeItem(item.id)"
										class="flex group w-9 h-9 p-2 justify-around z-10 hover:bg-ihh-slate-gray bg-ihh-gray/20 rounded-full font-bold text-xl text-ihh-midnight-gray"
									>
										<div class="m-auto items-center flex w-full justify-center">
											<div class="rotate-45 absolute rounded bg-ihh-midnight-gray group-hover:bg-ihh-white py-[1px] rounded-lg px-1.5"></div>
											<div class="-rotate-45 rounded bg-ihh-midnight-gray group-hover:bg-ihh-white py-[1px] rounded-lg px-1.5"></div>
										</div>
									</button>
								</div>
							</div>
						</div> -->
						<CartItemMobile
							v-for="{ item, quantity, variant, group, optional } in store.cart.cartItems"
							:key="item.id"
							:item="{ item, quantity, variant, group, optional }"
							:XCoverProducts="XCoverProducts"
							@reduce-qty="reduceItemQty"
							@increase-qty="increaseItemQty"
							@remove-item="removeItem"
						/>
					</div>

					<!-- Gift Certificates Table -->
					<div class="hidden md:flex px-8">
						<!-- <table :class="!store.certificatesCount ? 'hidden' : 'table-auto w-full justify-between'">
							<tbody class="table-auto w-full justify-between" v-for="(cert, index) in store.cart.certificates" :key="index">
								<tr class="border-b">
									<td class="flex items-center py-6 px-4">
										<div class="flex flex-col justify-center w-[80px] h-[80px] shrink-0 mr-6">
											<img
												src="https://cdn11.bigcommerce.com/s-nuj3c/stencil/29299650-2b9e-013d-ca92-06d759ad9f37/e/15c6ecf0-25f0-013d-e4f6-1e7f4d7752a0/img/GiftCertificate.png"
												class="w-full max-w-[80px] max-h-[80px] object-contain"
											/>
										</div>
										<div class="flex flex-col text-start px-4">
											<div class="items-center cursor-pointer text-ihh-dark-salmon hover:text-ihh-salmon underline underline-offset-2 font-semibold">
												Gift Certificate
											</div>
											<div class="text-ihh-slate-gray mt-2 pt-0 items-top text-xs">
												<div>
													<span class="text-ihh-midnight-gray font-medium">Recipient: </span>
													<span class="text-ihh-gray font-normal">{{ cert?.recipient?.name }}</span>
												</div>
												<div>
													<span class="text-ihh-midnight-gray font-medium">Email: </span>
													<span class="text-ihh-gray font-normal">{{ cert?.recipient?.email }}</span>
												</div>
											</div>
										</div>
									</td>
									<td class="py-6 px-4 text-center text-ihh-slate-gray">${{ cert.amount?.toFixed?.(2) }}</td>
									<td class="py-6 px-4 text-center text-ihh-slate-gray font-semibold">
										<div class="flex w-full justify-center">
											<div class="flex w-28 justify-around max-w-[100px]">
												<button
													@click="reduceCertQty(index)"
													class="shadow shadow-ihh-midnight-gray/20 m-auto flex w-5 h-5 rounded-full drop-shadow-2xl shadow-black bg-white items-center justify-center"
												>
													-
												</button>
												<div class="m-auto text-sm">{{ cert.quantity }}</div>
												<button
													@click="increaseCertQty(index)"
													class="shadow shadow-ihh-midnight-gray/20 m-auto flex w-5 h-5 rounded-full drop-shadow-2xl shadow-black bg-white items-center justify-center"
												>
													+
												</button>
											</div>
										</div>
									</td>
									<td class="py-6 px-4 ml-4 text-center text-ihh-slate-gray">
										<div class="flex w-full justify-center">
											<div class="flex m-auto items-center space-x-4">
												<span>${{ (cert.amount.toFixed?.(2) * cert.quantity).toFixed?.(2) }}</span>
											</div>
										</div>
									</td>
									<td class="py-6 px-4 ml-4 text-center text-ihh-slate-gray">
										<div class="flex w-full justify-center m-auto gap-x-2 sm:gap-x-6">
											<div class="">
												<button
													@click="removeCert(index)"
													class="flex group w-7 h-7 p-2 justify-around z-10 hover:bg-ihh-slate-gray bg-ihh-gray/20 rounded-full font-bold text-xl text-ihh-midnight-gray"
												>
													<div class="m-auto items-center flex w-full justify-center">
														<div class="rotate-45 absolute bg-ihh-midnight-gray group-hover:bg-ihh-white py-[0.5px] rounded px-1"></div>
														<div class="-rotate-45 bg-ihh-midnight-gray group-hover:bg-ihh-white py-[0.5px] rounded px-1"></div>
													</div>
												</button>
											</div>
										</div>
									</td>
								</tr>
							</tbody>
						</table> -->
						<table class="table-auto w-full justify-between">
							<tbody class="table-auto w-full justify-between">
								<CartCertificateDesktop
									v-for="(cert, index) in store.cart.certificates"
									:key="index"
									:certificate="cert"
									:index="index"
									@reduce-qty="reduceCertQty"
									@increase-qty="increaseCertQty"
									@remove-cert="removeCert"
								/>
							</tbody>
						</table>
					</div>

					<!-- Mobile Gift Certificates -->
					<div class="md:hidden mt-8 border-t">
						<!-- <div id="mobile-gift-certificates" v-for="(cert, index) in store.cart.certificates" :key="index" class="py-6 border-b last:pb-8">
							<div class="flex w-full justify-center my-6 space-x-2">
								<div class="flex flex-col justify-center w-[80px] h-[80px] shrink-0">
									<img
										src="https://cdn11.bigcommerce.com/s-nuj3c/stencil/29299650-2b9e-013d-ca92-06d759ad9f37/e/15c6ecf0-25f0-013d-e4f6-1e7f4d7752a0/img/GiftCertificate.png"
										class="max-w-[80px] max-h-[80px] object-contain rounded-lg"
									/>
								</div>
								<div class="w-full">
									<div class="flex w-full">
										<div class="text-ihh-midnight-gray w-full max-w-52 mr-4">
											<div class="font-semibold text-base text-ihh-dark-salmon">Gift Certificate</div>
										</div>
										<div class="text-ihh-midnight-gray text-lg">${{ cert.amount?.toFixed?.(2) }}</div>
									</div>
									<div class="text-ihh-midnight-gray font-semibold pt-2 px-2 text-xs">
										<div>
											<span>{{ `Recipient: ` }}</span>
											<span class="text-ihh-gray font-normal">{{ cert?.recipient?.name }}</span>
										</div>
										<div>
											<span>{{ `Email: ` }}</span>
											<span class="text-ihh-gray font-normal">{{ cert?.recipient?.email }}</span>
										</div>
									</div>
								</div>
							</div>

							<div class="flex w-full justify-between text-sm text-ihh-midnight-gray">
								<div class="flex w-32 justify-around max-w-[120px]">
									<button
										@click="reduceCertQty(index)"
										class="shadow shadow-ihh-midnight-gray/20 m-auto flex w-7 h-7 rounded-full drop-shadow-2xl shadow-black bg-white items-center justify-center text-lg font-medium"
									>
										-
									</button>
									<div class="m-auto text-base font-medium">{{ cert.quantity }}</div>
									<button
										@click="increaseCertQty(index)"
										class="shadow shadow-ihh-midnight-gray/20 m-auto flex w-7 h-7 rounded-full drop-shadow-2xl shadow-black bg-white items-center justify-center text-lg font-medium"
									>
										+
									</button>
								</div>
								<div class="">
									<button
										@click="removeCert(index)"
										class="flex group w-9 h-9 p-2 justify-around z-10 hover:bg-ihh-slate-gray bg-ihh-gray/20 rounded-full font-bold text-xl text-ihh-midnight-gray"
									>
										<div class="m-auto items-center flex w-full justify-center">
											<div class="rotate-45 absolute rounded bg-ihh-midnight-gray group-hover:bg-ihh-white py-[1px] rounded-lg px-1.5"></div>
											<div class="-rotate-45 rounded bg-ihh-midnight-gray group-hover:bg-ihh-white py-[1px] rounded-lg px-1.5"></div>
										</div>
									</button>
								</div>
							</div>
						</div> -->
						<CartCertificateMobile
							v-for="(cert, index) in store.cart.certificates"
							:key="index"
							:certificate="cert"
							:index="index"
							@reduce-qty="reduceCertQty"
							@increase-qty="increaseCertQty"
							@remove-cert="removeCert"
						/>
					</div>

					<div
						class="flex flex-col md:flex-row w-full items-center justify-center md:items-start pt-20 px-4 sm:px-8"
						:class="!store.cartTotalItems ? 'flex w-full justify-center' : 'gap-y-8 md:gap-x-8 md:justify-between'"
					>
						<div id="cart-summary" v-if="store.cartTotalItems" class="flex flex-col w-full md:max-w-xl text-ihh-gray-700 md:order-2 space-y-4">
							<!-- Subtotal -->
							<div class="flex justify-between mb-1 w-full border-b pb-4">
								<span class="font-bold">Subtotal:</span>
								<!-- <span class="flex w-full border-b border-dotted flex-grow m-auto items-center border-ihh-gray mx-4"></span> -->
								<span>{{ (store.cart.subTotal || store.cartSubtotal).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</span>
							</div>

							<!-- Tax -->
							<!-- <div
								v-if="(store.cart.tax || store.tsst) && checkout.isTexasShippingAddress"
								class="flex w-full m-auto items-center justify-between mb-1 w-full border-b pb-4"
							>
								<div class="whitespace-nowrap font-bold">Texas State Sales Tax:</div>
								<Spinner v-if="(store.cart.tax || store.tsst) === null" :small="true" class="w-4 h-4" color="border-t-ihh-salmon" />
								<div v-else>{{ (store.cart.tax || store.tsst)?.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</div>
							</div> -->

							<!-- Shipping -->
							<div class="w-full border-b pb-4">
								<div class="flex m-auto items-center justify-between mb-1">
									<div class="flex-grow">
										<div class="font-bold">Shipping:</div>
									</div>
									<!-- <div class="flex w-full border-b border-dotted flex-grow m-auto items-center border-ihh-gray mx-4"></div> -->
									<div>
										<button
											@click="showShippingInfo = !showShippingInfo"
											class="underline cursor-pointer w-16 text-right font-normal"
											:class="checkout.shipping.selectedShipping?.id ? 'hover:text-ihh-salmon text-ihh-dark-salmon' : ''"
										>
											{{ checkout.shippingText }}
										</button>
									</div>
								</div>
								<div>
									<Shipping v-if="showShippingInfo" @hideShipping="showShippingInfo = false" class="text-ihh-midnight-gray" />
								</div>
							</div>

							<!-- Coupon Code -->
							<div class="w-full border-b pb-4">
								<Coupon :style="{ title: 'font-bold text-ihh-gray-700', remove: 'text-sm' }" />
							</div>

							<!-- Gift Certificate -->
							<div class="w-full border-b pb-4">
								<Certificate :style="{ title: 'font-bold text-ihh-gray-700', remove: 'text-sm' }" />
							</div>

							<!-- Total -->
							<div class="flex justify-between text-2xl text-ihh-midnight-gray font-bold mt-10">
								<span>Total</span>
								<Spinner v-if="store.cart.tax === null" :small="true" class="w-4 h-4" color="border-t-ihh-salmon" />
								<span v-else>{{ checkout.displayTotal?.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</span>
							</div>
						</div>

						<!-- Checkout Buttons -->
						<div class="flex flex-col space-y-4 w-full md:max-w-sm md:order-1">
							<button
								:class="[
									{ 'opacity-40 pointer-events-none': emptyCart || store.cart?.tax === null },
									'rounded flex text-center items-center justify-center text-sm md:text-base text-ihh-midnight-gray py-3 px-10 w-full bg-ihh-dark-salmon hover:bg-ihh-salmon duration-150 tracking-wide font-semibold transition-transform active:scale-95 shadow-md hover:shadow-lg',
								]"
							>
								<router-link to="/checkout" class="w-full h-full flex items-center justify-center text-[16px] text-ihh-midnight-gray no-underline">
									Proceed to Checkout
									<div v-if="!emptyCart" class="ml-1 flex">
										<Spinner v-if="store.cart.tax === null" :small="true" class="w-4 h-4" color="border-t-ihh-salmon" />
										<span v-else>({{ checkout.displayTotal?.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }})</span>
									</div>
								</router-link>
							</button>
							<button
								@click="emptyBag"
								class="rounded flex text-[16px] w-full text-center justify-center text-ihh-midnight-gray border-3 border-ihh-salmon px-8 py-3 hover:bg-ihh-salmon duration-150 whitespace-nowrap font-semibold"
								:class="[{ 'opacity-40 pointer-events-none': !store.cart.cartItems.length }]"
							>
								Remove all items
							</button>
						</div>
					</div>

					<!-- <div v-if="store.cartTotalItems" class="w-full flex justify-end px-7 my-8 text-ihh-form-input-entry text-base">
						<div class="">-- or use --</div>
					</div> -->

					<!-- Digital Wallets -->
					<!-- <div v-show="store.cartTotalItems" class="w-full pr-2 md:pr-7 flex flex-col md:flex-row items-center md:justify-end relative">
						<div class="w-80 md:w-64">
							<div class="w-full flex justify-end mb-4">
								<div id="paylater-message" class="min-h-[30px]"></div>
							</div>
							<div class="flex flex-col space-y-2 w-full">
								<PayPalButton layout="column" :messages="true" />
								<div v-if="showVenmo">
									<VenmoButton @updateShowVenmo="handleVenmoAvailability" />
								</div>
								<div :class="[!showApplePay ? 'hidden' : '']">
									<ApplePayButton @updateAvailability="handleAppleAvailability" />
								</div>
							</div>
						</div>
					</div> -->
				</div>
			</CartItems>
		</div>
	</div>
</template>

<script>
import CartItems from '../../layout/cart-items.vue'
import CartItemDesktop from '../../layout/cart-item-desktop.vue'
import CartItemMobile from '../../layout/cart-item-mobile.vue'
import CartCertificateDesktop from '../../layout/cart-certificate-desktop.vue'
import CartCertificateMobile from '../../layout/cart-certificate-mobile.vue'
import Spinner from '../../layout/spinner.vue'
import UpsellScroller from '../../partials/upsell-scroller.vue'
import Shipping from './shipping.vue'
import LogoSmall from '../../partials/logo-small.vue'
import PayPalButton from '../../checkout/paypal-button.vue'
import VenmoButton from '../../checkout/venmo-button.vue'
import ApplePayButton from '../../checkout/apple-pay-button.vue'
import FooterLogo from '../../partials/footer-logo.vue'
import { useCheckoutStore } from '../../../stores/store.js'
import Coupon from '../../checkout/coupon.vue'
import Certificate from '../../checkout/certificate.vue'

export default {
	components: {
		CartItems,
		CartItemDesktop,
		CartItemMobile,
		CartCertificateDesktop,
		CartCertificateMobile,
		UpsellScroller,
		Shipping,
		Spinner,
		Coupon,
		Certificate,
		VenmoButton,
		LogoSmall,
		PayPalButton,
		ApplePayButton,
		FooterLogo,
	},
	inject: ['store'],
	data() {
		return {
			checkout: useCheckoutStore(),
			showApplePay: true,
			showVenmo: true,
			showShippingInfo: false,
			XCoverProducts: [3693, 3694, 3900, 3901],
		}
	},
	methods: {
		toggleBag() {
			console.log('toggleBag clicked')
			this.store.showBag = !this.store.showBag
		},
		handleAppleAvailability(value) {
			this.showApplePay = value
		},
		handleVenmoAvailability(value) {
			this.showVenmo = value
		},
	},
	computed: {
		emptyCart() {
			return this.store.cart?.cartItems?.length === 0 && this.store.cart?.certificates?.length === 0
		},
	},
}
</script>

<style scoped>
input {
	@apply outline-none focus:ring-ihh-midnight-gray focus:border-ihh-midnight-gray;
}
</style>
